'use client';
import { useState } from 'react';
import { Image, ValImage } from '@valbuild/next';

interface HotspotImageProps {
  image: Image;
  className?: string;
  clickable?: boolean;
  alt?: string;
}

const HotspotImage = ({
  image,
  className,
  alt,
  clickable,
}: HotspotImageProps) => {
  const [clicked, setClicked] = useState<boolean>(false);

  const handleImageClose = () => {
    setClicked(false);
    document.body.style.overflow = 'auto';
  };

  const handleImageClick = () => {
    if (!clickable) return;
    setClicked(true);
    document.body.style.overflow = 'hidden';
  };

  return (
    <>
      {clickable && clicked && (
        <div
          className="fixed top-0 left-0 z-50 w-screen h-screen bg-black bg-opacity-90"
          onClick={handleImageClose}
        >
          <div className="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] flex justify-center">
            <div className="p-8 box-border w-[90vw] h-[90vh] relative">
              <ValImage
                className={`${className} object-contain`}
                src={image}
                alt={alt || image.metadata?.alt || 'Bilde'}
                fill
                sizes={'1200px'}
              />
            </div>
          </div>
        </div>
      )}
      <ValImage
        onClick={handleImageClick}
        className={`${className} object-cover`}
        src={image}
        alt={alt || image.metadata?.alt || 'Bilde'}
        fill
        sizes={'1200px'}
      />
    </>
  );
};

export default HotspotImage;
